import { render, staticRenderFns } from "./topProduct.vue?vue&type=template&id=4f90e18a&"
import script from "./topProduct.vue?vue&type=script&lang=js&"
export * from "./topProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports